import { render, staticRenderFns } from "./QuestionAdd.vue?vue&type=template&id=0413a5e3&"
import script from "./QuestionAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionAdd.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/vue-form-wizard/vue-form-wizard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports